import { render, staticRenderFns } from "./LiveStreamAnnouncement.vue?vue&type=template&id=400bce4e&scoped=true&"
import script from "./LiveStreamAnnouncement.vue?vue&type=script&lang=ts&"
export * from "./LiveStreamAnnouncement.vue?vue&type=script&lang=ts&"
import style0 from "./LiveStreamAnnouncement.vue?vue&type=style&index=0&id=400bce4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400bce4e",
  null
  
)

export default component.exports